import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: () => import('../views/Landing.vue')
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/Error.vue')
  },
  {
    path: '/:room/teacher',
    name: 'Teacher',
    component: () => import('../views/Teacher.vue')
  },
  { 
    path: '/:room', redirect: to => {
      return `/${to.params.room}/student/2`;
    }
  },
  {
    path: '/:room/student',
    name: 'Student',
    component: () => import('../views/Student.vue'),
    children: [
      {
        path: '1',
        component: () => import('../components/Help.vue')
      },
      {
        path: '2',
        component: () => import('../components/OnIt.vue')
      },
      {
        path: '3',
        component: () => import('../components/Done.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
